import { ITracingSegment } from "../../infrastructure/tracing-segment.interface";
import { BaseChainableComponent } from "../components/pipeline/base-chainable-component";
import { IProcessable } from "../components/pipeline/processable.interface";

export class TracingComponent<InputType, OutputType> extends BaseChainableComponent<OutputType> implements IProcessable<InputType> {

	private parentSegment: ITracingSegment;
	private segment: ITracingSegment;
	private component: IProcessable<InputType>;

	constructor(component: IProcessable<InputType>, parentSegment: ITracingSegment) {
		super();

		this.component = component;
		this.parentSegment = parentSegment;
	}

	public getSegment() {
		return this.segment;
	}

	public async process(input: InputType) {
		this.segment = this.parentSegment.addNewSubsegment(this.component.constructor.name);
		let output;

		try {
			output = await this.component.process(input);
		} catch (e) {
			this.segment.addError(e);
			throw e;
		} finally {
			this.segment.close();
		}

		return await this.next.process(output);

	}
}
